import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDoubleCheckmark2Small"><Path d="M15.5586 7.92969L15.0645 8.49414L8.06445 16.4941L7.53613 17.0977L6.96973 16.5303L3.43945 13L4.5 11.9395L7.46289 14.9023L13.9355 7.50586L14.4297 6.94141L15.5586 7.92969ZM20.5586 7.92969L20.0645 8.49414L13.0645 16.4941L12.5703 17.0586L11.4414 16.0703L11.9355 15.5059L18.9355 7.50586L19.4297 6.94141L20.5586 7.92969Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoubleCheckmark2Small;
